import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function TopNav({ onMenuClick }) {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchTerm.trim().length >= 2) {
      navigate(`/search?q=${encodeURIComponent(searchTerm.trim())}`);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 lg:left-64 z-50 flex h-14 items-center gap-3 border-b border-outline-variant/20 bg-surface-container-low/85 glass-effect px-4 sm:px-6 lg:px-8">
      <button
        type="button"
        onClick={onMenuClick}
        aria-label="Open navigation"
        className="lg:hidden flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-on-surface-variant hover:bg-surface-container-highest hover:text-on-surface transition-colors"
      >
        <span className="material-symbols-outlined">menu</span>
      </button>

      <Link
        to="/leagues"
        className="hidden md:inline-flex shrink-0 items-center gap-1.5 rounded-full border border-secondary/20 bg-secondary/10 px-3 py-1.5 font-label text-[10px] font-semibold uppercase tracking-[0.12em] text-secondary transition-colors hover:border-secondary/40"
      >
        <span className="h-1.5 w-1.5 rounded-full bg-secondary" />
        15 Leagues Tracked
      </Link>

      <form onSubmit={handleSearch} className="ml-auto flex min-w-0 flex-1 items-center sm:flex-none">
        <div className="relative group w-full">
          <span className="material-symbols-outlined pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-lg text-on-surface-variant group-focus-within:text-primary transition-colors">
            search
          </span>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="h-10 w-full sm:w-64 lg:w-72 rounded-full border border-outline-variant/20 bg-surface-container-lowest pl-10 pr-4 text-sm text-on-surface placeholder:text-on-surface-variant/40 focus:outline-none focus:ring-2 focus:ring-primary/70"
            placeholder="Search players, clubs or leagues..."
          />
        </div>
      </form>
    </header>
  );
}
